import { render, staticRenderFns } from "./_base-add-new-card.vue?vue&type=template&id=4a51e8ee&scoped=true&"
import script from "./_base-add-new-card.vue?vue&type=script&lang=js&"
export * from "./_base-add-new-card.vue?vue&type=script&lang=js&"
import style0 from "./_base-add-new-card.vue?vue&type=style&index=0&id=4a51e8ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a51e8ee",
  null
  
)

export default component.exports